/* EG Collections — Client Render (ES5-safe; template cloning + client pagination) */

(function () {
  function egClientRenderInit(root) {
    if (!root || root.__egClientRenderBound) return false;

    // Hard requirements (reuse existing helpers from other split files)
    if (typeof egGetFullCollectionProducts !== "function") return false;
    if (typeof egProductMatchesSelections !== "function") return false;
    if (typeof egGetActiveShopifyFacetSelectionsFromUrl !== "function") return false;
    if (typeof egBuildEgTagSelectionsFromUrlAsFullTags !== "function") return false;
    if (typeof egGetLiteHandle !== "function") return false;
    if (typeof egGetLiteAvailable !== "function") return false;

    var listEl = (typeof egGetProductListEl === "function") ? egGetProductListEl(document) : null;
    if (!listEl) return false;

    root.__egClientRenderBound = true;
    root.__egClientRenderActive = true;

    // Ensure filter UI is initialised (since init() may exit early in client-only mode)
    if (typeof applyCollectionFilterConfig === "function") applyCollectionFilterConfig(root);

    if (typeof renderTagGroups === "function") {
      renderTagGroups(root);

      // IMPORTANT: re-apply ordering now that tag groups exist
      if (typeof applyCollectionFilterConfig === "function") applyCollectionFilterConfig(root);
    }

    if (typeof egApplyFilterOptionOrdering === "function") egApplyFilterOptionOrdering(root);
    if (typeof bindDropdownOverlay === "function") bindDropdownOverlay(root);
    if (typeof bindPriceRangeNavigation === "function") bindPriceRangeNavigation(root);
    if (typeof bindClearFilters === "function") bindClearFilters(root);

    if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
    if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();

    if (typeof egUpdateEgTagGroupCountsAndDisabledFromLite === "function") {
      try { egUpdateEgTagGroupCountsAndDisabledFromLite(root); } catch (e) {}
    }

  function egReadSortKeyFromUrl() {
    var sp = new URLSearchParams(window.location.search || "");
    return sp.get("eg_sort") || "featured";
  }

  function egClientRenderIsDbModeOn() {
    try {
      var sp = new URLSearchParams(window.location.search || "");
      return sp.get("eg_show_legacy") === "1";
    } catch (e) {
      return false;
    }
  }

  function egFindTagByPrefix(tags, prefix) {
    if (!tags || !tags.length || !prefix) return "";
    var pfx = String(prefix);

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "").trim();
      if (t.indexOf(pfx) !== 0) continue;

      var raw = String(t.slice(pfx.length) || "").trim();

      // Ignore range-style tags like "401mm-500mm"
      if (raw.indexOf("-") !== -1 || raw.indexOf("–") !== -1) continue;

      return raw;
    }
    return "";
  }

  function egGetSortPillTextForProduct(p) {
    var sortKey = egReadSortKeyFromUrl();
    if (!sortKey || sortKey === "featured") return "";

    var rule = egGetCustomSortRule(sortKey);
    if (!rule || !rule.def) return "";

    var def = rule.def;
    var kind = String(def.kind || "");
    var tags = (p && p.tags && p.tags.length) ? p.tags : [];

    var label = "";
    var value = "";

    // Label: based on def key/prefix
    if (kind === "tag_number") {
      var pref = String(def.prefix || "");
      if (pref === "Thickness_") label = "Thickness";
      else if (pref === "Width_") label = "Width";
      else if (pref === "Length_") label = "Length";
      else if (pref === "Height_") label = "Height";
      else if (pref === "Sleeve-Length__") label = "Sleeve";
      else if (pref === "Total Keys__") label = "No. of Keys";
      else label = "Spec";

      value = egFindTagByPrefix(tags, def.prefix || "");
      if (!value) return "";
      // value already includes unit (e.g. "4mm", "410mm")
      return label + ": " + value;
    }

    if (kind === "tag_rank") {
      var pref2 = String(def.prefix || "");
      if (pref2 === "Surface Texture__") label = "Texture";
      else if (pref2 === "Firmness__") label = "Firmness";
      else label = "Spec";

      value = egFindTagByPrefix(tags, def.prefix || "");
      if (!value) return "";
      return label + ": " + value;
    }

    if (kind === "tag_area") {
      // Prefer explicit Area_ tag (e.g. "Area_1968cm2")
      var a = egFindTagByPrefix(tags, "Area_");
      if (a) {
        label = "Size";
        // prettify cm2 -> cm²
        var pretty = String(a).replace(/cm2\b/i, "cm²");
        return label + ": " + pretty;
      }

      // Fallback: Width_ + Length_ tags (if Area_ missing)
      var w = egFindTagByPrefix(tags, def.width_prefix || "Width_");
      var l = egFindTagByPrefix(tags, def.length_prefix || "Length_");
      if (!w || !l) return "";
      label = "Size";
      return label + ": " + l + " × " + w;
    }

    return "";
  }

  function egApplySortSpecPill(tile, p) {
    if (!tile) return;

    // remove old sort pill if any
    var old = tile.querySelector(".eg-card-pills--sort");
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var text = egGetSortPillTextForProduct(p);
    if (!text) return;

    var wrap = document.createElement("div");
    wrap.className = "eg-card-pills eg-card-pills--sort";

    var pill = document.createElement("span");
    pill.className = "eg-card-pill";
    pill.textContent = text;

    wrap.appendChild(pill);
    tile.appendChild(wrap);
  }

    function egApplyPickerRecommendationBadge(tile, p, renderRank, collectionHandle) {
    if (!tile) return;

    var old = tile.querySelector(".eg-card-pills--picker-rec");
    if (old && old.parentNode) old.parentNode.removeChild(old);

    tile.classList.remove("eg-product-item--picker-best");
    tile.classList.remove("eg-product-item--picker-top");

    if (typeof egGetPickerProductScore !== "function") return;
    if (typeof egReadPickerSoftStateFromUrl !== "function") return;

    var pickerState = egReadPickerSoftStateFromUrl();
    if (!pickerState) return;
    if (!pickerState.movement_space && !pickerState.secondary_priority) return;

    var currentPage = 1;
    var currentSort = "";
    try {
      var u = new URL(window.location.href);
      currentPage = parseInt(u.searchParams.get("page") || "1", 10);
      currentSort = String(u.searchParams.get("eg_sort") || "");
    } catch (e) {}

    if (currentPage !== 1) return;
    if (currentSort && currentSort !== "featured") return;

    if (!(renderRank === 0 || renderRank === 1 || renderRank === 2)) return;

    var label = "";
    var pillClass = "eg-card-pill";
    var tileClass = "";

    if (renderRank === 0) {
      label = "Best Match";
      pillClass += " eg-card-pill--best-match";
      tileClass = "eg-product-item--picker-best";
    } else if (renderRank === 1 || renderRank === 2) {
      label = "Top Pick";
      pillClass += " eg-card-pill--top-pick";
      tileClass = "eg-product-item--picker-top";
    } else {
      return;
    }

    var wrap = document.createElement("div");
    wrap.className = "eg-card-pills eg-card-pills--picker-rec";

    var pill = document.createElement("span");
    pill.className = pillClass;
    pill.textContent = label;

    wrap.appendChild(pill);
    tile.appendChild(wrap);

    if (tileClass) tile.classList.add(tileClass);
  }

  function egToNum(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  function egCompareStr(a, b) {
    a = String(a || "").toLowerCase();
    b = String(b || "").toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }

    function egGetCollectionHandleFromDom() {
    var el = document.getElementById("eg-collection-filters");
    return (el && el.dataset && el.dataset.egCollection) ? el.dataset.egCollection : "";
  }

  function egPickerRankingIsActive() {
    if (typeof egReadPickerSoftStateFromUrl !== "function") return false;

    var st = null;
    try { st = egReadPickerSoftStateFromUrl(); } catch (e) { st = null; }

    if (!st) return false;

    return !!(
      (st.movement_space && String(st.movement_space).replace(/^\s+|\s+$/g, "")) ||
      (st.secondary_priority && String(st.secondary_priority).replace(/^\s+|\s+$/g, ""))
    );
  }

  function egGetCustomSortRule(sortKey) {
    var cfg = window.EG_COLLECTION_SORT_CONFIG;
    if (!cfg || !sortKey) return null;

    var handle = egGetCollectionHandleFromDom();

    var col = (cfg.collections && handle && cfg.collections[handle]) ? cfg.collections[handle] : null;
    if (!col || !col.custom || !col.custom[sortKey]) return null;

    var rule = col.custom[sortKey];
    var defKey = rule && rule.def ? rule.def : null;

    // defs can exist at defaults.defs, and optionally per-collection defs too
    var def =
      (col && col.defs && defKey && col.defs[defKey]) ? col.defs[defKey] :
      (cfg.defaults && cfg.defaults.defs && defKey && cfg.defaults.defs[defKey]) ? cfg.defaults.defs[defKey] :
      null;

    if (!def) return null;

    return {
      def: def,
      dir: rule.dir || "asc"
    };
  }

  function egBuildRankMap(orderArr) {
    var map = {};
    if (!orderArr || !orderArr.length) return map;
    for (var i = 0; i < orderArr.length; i++) map[String(orderArr[i])] = i + 1;
    return map;
  }

  function egGetTagRankValue(tags, def) {
    // def.kind === "tag_rank"
    // find first tag that matches prefix and return its order rank
    if (!tags || !tags.length || !def || !def.prefix) return 999999;

    var rankMap = egBuildRankMap(def.order || []);
    var prefix = String(def.prefix);

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "");
      if (t.indexOf(prefix) !== 0) continue;

      var val = t.slice(prefix.length).trim();
      if (rankMap[val]) return rankMap[val];
      // unknown size goes to bottom
      return 999998;
    }

    // missing size tag goes to bottom
    return 999999;
  }

  function egGetTagNumberValue(tags, prefix, unit) {
    if (!tags || !tags.length || !prefix) return 999999999;

    var pfx = String(prefix);

    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || "").trim();
      if (t.indexOf(pfx) !== 0) continue;

      var raw = t.slice(pfx.length); // e.g. "490mm" or "9511mm-1200mm"
      raw = String(raw || "").trim();

      // Ignore range-style garbage tags like "9511mm-1200mm" (or en-dash)
      if (raw.indexOf("-") !== -1 || raw.indexOf("–") !== -1) {
        continue; // keep looking for the real Width_490mm tag
      }

      if (unit) raw = raw.replace(String(unit), "");
      raw = raw.replace(/[^0-9.]/g, "");

      var n = parseFloat(raw);
      if (isFinite(n)) return n;

      // malformed numeric -> keep looking for another matching tag
      continue;
    }

    // missing/unknown goes to bottom
    return 999999999;
  }

  function egGetAreaMm2(tags, widthPrefix, lengthPrefix, unit) {
    var w = egGetTagNumberValue(tags, widthPrefix, unit);
    var l = egGetTagNumberValue(tags, lengthPrefix, unit);

    if (!isFinite(w) || !isFinite(l)) return 999999999999;
    if (w >= 999999998 || l >= 999999998) return 999999999999;

    return w * l;
  }

  function egSortLiteWithinStockBuckets(arr, sortKey) {
    if (!arr || arr.length < 2) return arr;

    // Custom sorts (per collection config)
    var custom = egGetCustomSortRule(sortKey);
    if (custom && custom.def) {
      var dir = (custom.dir === "desc") ? -1 : 1;
      var def = custom.def;
      var dbModeOn = egClientRenderIsDbModeOn();

      function byCustom(a, b) {
        var ta = a && a.tags ? a.tags : [];
        var tb = b && b.tags ? b.tags : [];

        var va = 999999999;
        var vb = 999999999;

        if (def.kind === "tag_rank") {
          va = egGetTagRankValue(ta, def);
          vb = egGetTagRankValue(tb, def);
        } else if (def.kind === "tag_number") {
          va = egGetTagNumberValue(ta, def.prefix, def.unit);
          vb = egGetTagNumberValue(tb, def.prefix, def.unit);
        } else if (def.kind === "tag_area") {
          va = egGetAreaMm2(ta, def.width_prefix, def.length_prefix, def.unit);
          vb = egGetAreaMm2(tb, def.width_prefix, def.length_prefix, def.unit);
        }

        if (va !== vb) return (va - vb) * dir;

        var taTitle = String((a && a.title) || "").toLowerCase();
        var tbTitle = String((b && b.title) || "").toLowerCase();
        if (taTitle < tbTitle) return -1;
        if (taTitle > tbTitle) return 1;
        return 0;
      }

      // DB Mode ON = disable stock-first, sort globally
      if (dbModeOn) {
        var globalSorted = arr.slice(0);
        globalSorted.sort(byCustom);
        return globalSorted;
      }

      // DB Mode OFF = keep stock-first invariant
      var inArr2 = [];
      var outArr2 = [];

      for (var ii = 0; ii < arr.length; ii++) {
        var pp = arr[ii];
        if (egLiteIsAvailable(pp)) inArr2.push(pp);
        else outArr2.push(pp);
      }

      inArr2.sort(byCustom);
      outArr2.sort(byCustom);

      return inArr2.concat(outArr2);
    }

    var rankingHandle = String((root && root.dataset && root.dataset.egCollection) || "");

    var pickerRankingActive = egPickerRankingIsActive();
    var sortParam = "";
    try {
      var u = new URL(window.location.href);
      sortParam = u.searchParams.get("eg_sort") || "";
    } catch (e) {}

    var isDefaultSort = !sortParam || sortParam === "featured";

    // Picker active + default sort = use picker ranking across the full visible set
    if (typeof egSortProductsByPickerScore === "function" && pickerRankingActive && isDefaultSort) {
      return egSortProductsByPickerScore(
        arr.slice(0),
        rankingHandle,
        (window.EG_COLLECTION_PICKER_RANKING &&
         window.EG_COLLECTION_PICKER_RANKING.handles &&
         window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle] &&
         window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights)
          ? window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights
          : {}
      );
    }

    // Manual sort selected = sort globally, not stock-first
    if (!isDefaultSort) {
      var arrSorted = arr.slice(0);

      function byNewest(a, b) {
        var da = a && (a.published_at || a.created_at) ? Date.parse(a.published_at || a.created_at) : 0;
        var db = b && (b.published_at || b.created_at) ? Date.parse(b.published_at || b.created_at) : 0;
        return (db || 0) - (da || 0);
      }

      function byPriceAsc(a, b) { return egToNum(a.price_min) - egToNum(b.price_min); }
      function byPriceDesc(a, b) { return egToNum(b.price_min) - egToNum(a.price_min); }
      function byTitleAsc(a, b) { return egCompareStr(a.title, b.title); }
      function byTitleDesc(a, b) { return egCompareStr(b.title, a.title); }

      var cmpGlobal = null;
      if (sortKey === "price_asc") cmpGlobal = byPriceAsc;
      else if (sortKey === "price_desc") cmpGlobal = byPriceDesc;
      else if (sortKey === "title_asc") cmpGlobal = byTitleAsc;
      else if (sortKey === "title_desc") cmpGlobal = byTitleDesc;
      else if (sortKey === "newest") cmpGlobal = byNewest;

      if (cmpGlobal) arrSorted.sort(cmpGlobal);

      return arrSorted;
    }

    var dbModeOn = egClientRenderIsDbModeOn();

    function byNewest(a, b) {
      // Prefer published date, fall back to created date
      var da = a && (a.published_at || a.created_at) ? Date.parse(a.published_at || a.created_at) : 0;
      var db = b && (b.published_at || b.created_at) ? Date.parse(b.published_at || b.created_at) : 0;

      // Newest first
      return (db || 0) - (da || 0);
    }

    function byPriceAsc(a, b) { return egToNum(a.price_min) - egToNum(b.price_min); }
    function byPriceDesc(a, b) { return egToNum(b.price_min) - egToNum(a.price_min); }
    function byTitleAsc(a, b) { return egCompareStr(a.title, b.title); }
    function byTitleDesc(a, b) { return egCompareStr(b.title, a.title); }

    var cmp = null;
    if (sortKey === "price_asc") cmp = byPriceAsc;
    else if (sortKey === "price_desc") cmp = byPriceDesc;
    else if (sortKey === "title_asc") cmp = byTitleAsc;
    else if (sortKey === "title_desc") cmp = byTitleDesc;
    else if (sortKey === "newest") cmp = byNewest;
    else cmp = null; // featured = leave current order unless picker ranking applies

    // DB Mode ON = disable stock-first entirely
    if (dbModeOn) {
      var dbArr = arr.slice(0);

      if (typeof egSortProductsByPickerScore === "function") {
        dbArr = egSortProductsByPickerScore(
          dbArr,
          rankingHandle,
          (window.EG_COLLECTION_PICKER_RANKING &&
          window.EG_COLLECTION_PICKER_RANKING.handles &&
          window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle] &&
          window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights)
            ? window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights
            : {}
        );
      }

      if (cmp) dbArr.sort(cmp);
      return dbArr;
    }

    // DB Mode OFF = keep stock-first invariant
    var inArr = [];
    var outArr = [];

    for (var i = 0; i < arr.length; i++) {
      var p = arr[i];
      if (egLiteIsAvailable(p)) inArr.push(p);
      else outArr.push(p);
    }

    if (typeof egSortProductsByPickerScore === "function") {
      inArr = egSortProductsByPickerScore(
        inArr,
        rankingHandle,
        (window.EG_COLLECTION_PICKER_RANKING &&
        window.EG_COLLECTION_PICKER_RANKING.handles &&
        window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle] &&
        window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights)
          ? window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights
          : {}
      );

      outArr = egSortProductsByPickerScore(
        outArr,
        rankingHandle,
        (window.EG_COLLECTION_PICKER_RANKING &&
        window.EG_COLLECTION_PICKER_RANKING.handles &&
        window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle] &&
        window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights)
          ? window.EG_COLLECTION_PICKER_RANKING.handles[rankingHandle].weights
          : {}
      );
    }

    if (cmp) {
      inArr.sort(cmp);
      outArr.sort(cmp);
    }

    return inArr.concat(outArr);
  }

    // Capture a DOM template from the first suitable tile
    var tiles0 = listEl ? listEl.querySelectorAll(".product-item") : null;
    var firstTile = null;
    var i = 0;

    for (i = 0; i < tiles0.length; i++) {
      var t = tiles0[i];
      if (!t) continue;
      if (!t.querySelector("a.product-item__title")) continue;
      if (!t.querySelector("a.product-item__image-wrapper")) continue;

      // must have add form + variant id
      var addForm = t.querySelector('form[action*="/cart/add"]');
      if (!addForm) continue;
      if (!addForm.querySelector('input[name="id"]')) continue;

      // Theme can use <button> without type="submit" (still posts the form)
      if (!addForm.querySelector('button[type="submit"], input[type="submit"], button, input[type="button"]')) continue;

      firstTile = t;
      break;
    }
    if (!firstTile) return false;

    var templateTile = firstTile.cloneNode(true);

    // Strip blocks we always remove (saves work per clone)
    var spec0 = templateTile.querySelector(".card-content-2");
    if (spec0) spec0.parentNode.removeChild(spec0);
    var inv0 = templateTile.querySelector(".product-item__inventory");
    if (inv0) inv0.parentNode.removeChild(inv0);

    var pills0 = templateTile.querySelector(".eg-card-pills");
    if (pills0) pills0.parentNode.removeChild(pills0);

    // Strip theme-generated label/badge blocks so we don't clone the first product's labels onto all cards
    var labelNodes = templateTile.querySelectorAll(
      ".product-label-list, .product-item__labels, .product-item__label-list, .product-item__badges, .product-badges, .product-badge-list, .product-badge, .badge-list, .badge"
    );
    for (i = 0; i < labelNodes.length; i++) {
      if (labelNodes[i] && labelNodes[i].parentNode) labelNodes[i].parentNode.removeChild(labelNodes[i]);
    }

    // Page size from current grid
    var pageSize = 48;
    var initialPageSize = 48;

    function getOrCreatePager() {
      var host = document.querySelector("[data-eg-client-pager]") || document.getElementById("eg-client-pager");
      if (host) return host;

      host = document.createElement("div");
      host.id = "eg-client-pager";
      host.setAttribute("data-eg-client-pager", "1");

      var themePag =
        document.querySelector(".pagination") ||
        document.querySelector(".collection__pagination") ||
        document.querySelector("[data-pagination]") ||
        null;

      if (themePag && themePag.parentNode) {
        themePag.parentNode.insertBefore(host, themePag);
      } else if (listEl.parentNode) {
        if (listEl.nextSibling) listEl.parentNode.insertBefore(host, listEl.nextSibling);
        else listEl.parentNode.appendChild(host);
      } else {
        document.body.appendChild(host);
      }

      host.style.display = "";
      host.style.visibility = "visible";
      return host;
    }

    function hideThemePagination() {
      var themePag =
        document.querySelector(".pagination") ||
        document.querySelector(".collection__pagination") ||
        document.querySelector("[data-pagination]") ||
        null;
      if (themePag) themePag.style.display = "none";
    }

    function readPageNumFromUrl() {
      try {
        var u2 = new URL(window.location.href, window.location.origin);
        var p = parseInt(u2.searchParams.get("page") || "1", 10);
        return (isFinite(p) && p > 0) ? p : 1;
      } catch (e) {
        return 1;
      }
    }

    function writeUrlNoReload(nextUrl) {
      window.history.pushState({}, "", nextUrl);

      // Convert long facet params -> pretty aliases immediately after writing.
      if (typeof egApplyPrettyUrlToAddressBar === "function") {
        try { egApplyPrettyUrlToAddressBar(); } catch (e) {}
      }
    }

    var __egSkeletonShowing = false;

    function egShowGridSkeleton() {
      if (__egSkeletonShowing) return;
      __egSkeletonShowing = true;

      // Replace server cards with skeleton cards while loading
      clearNode(listEl);

      var frag = document.createDocumentFragment();
      var n = 12; // match your SEO server render count

      for (var i = 0; i < n; i++) {
        // Clone a real tile so we inherit the theme's grid sizing classes
        var tile = templateTile.cloneNode(false); // shallow clone (keeps classes/attrs)

        // Ensure expected class exists (defensive)
        if (tile.className && tile.className.indexOf("product-item") === -1) {
          tile.className += " product-item";
        }

        // Skeleton markup inside the tile
        tile.innerHTML =
          '<div class="eg-skel-card eg-skel-shimmer">' +
            '<div class="eg-skel-img"></div>' +
            '<div class="eg-skel-body">' +
              '<div class="eg-skel-line w40"></div>' +
              '<div class="eg-skel-line w60"></div>' +
              '<div class="eg-skel-line w80"></div>' +
              '<div class="eg-skel-line w30"></div>' +
            '</div>' +
          '</div>';

        frag.appendChild(tile);
      }

      listEl.style.display = "";
      listEl.appendChild(frag);
    }

    function setLoading(isLoading) {
      if (document && document.documentElement && document.documentElement.classList) {
        document.documentElement.classList.toggle("eg-collection-loading", !!isLoading);
      }

      if (isLoading) egShowGridSkeleton();
      else __egSkeletonShowing = false;

      // Keep existing hook (if you use it elsewhere)
      if (typeof egSetProductListPending === "function") {
        egSetProductListPending(!!isLoading);
      }
    }

    function normalizeMoney(val) {
      if (val == null) return "";
      if (typeof val === "string") return val.replace(/^\s+|\s+$/g, "");
      if (typeof val === "number") {
        var pounds = val > 1000 ? (val / 100) : val;
        return "£" + pounds.toFixed(2);
      }
      return "";
    }

    function getLiteTitle(p) {
      var s = (p && (p.title || p.name || p.product_title || p.productTitle)) || "";
      return String(s).replace(/^\s+|\s+$/g, "");
    }

    function getLiteUrl(p) {
      var h = egGetLiteHandle(p);
      if (!h) return "";
      return "/products/" + encodeURIComponent(String(h));
    }

    function getLiteImage(p) {
      var s = (p && (
        p.image ||
        p.featured_image ||
        p.featuredImage ||
        p.image_url ||
        p.imageUrl ||
        p.primary_image ||
        p.primaryImage
      )) || "";
      return String(s).replace(/^\s+|\s+$/g, "");
    }

    function getLitePriceText(p) {
      var min = (p && p.price_min != null) ? String(p.price_min).replace(/^\s+|\s+$/g, "") : "";
      var cur = (p && p.currency) ? String(p.currency).replace(/^\s+|\s+$/g, "") : "";

      if (min) {
        var nn = Number(min);
        if (isFinite(nn)) {
          if (!cur || cur === "GBP") return "£" + nn.toFixed(2);
          return cur + " " + nn.toFixed(2);
        }
        if (!cur || cur === "GBP") return "£" + min;
        return cur + " " + min;
      }

      var raw = p && (p.price || p.price_text || p.priceText || p.price_formatted || p.priceFormatted);
      var s = normalizeMoney(raw);
      if (s) return s;

      var cents = p && (p.price_cents || p.priceCents || p.price_min_cents || p.priceMinCents);
      if (typeof cents === "number") return normalizeMoney(cents);
      if (typeof cents === "string") {
        var n2 = parseInt(cents, 10);
        if (isFinite(n2)) return normalizeMoney(n2);
      }

      return "";
    }

    function egGidToNumericId(gid) {
      var s = String(gid || "").replace(/^\s+|\s+$/g, "");
      if (!s) return "";
      var idx = s.lastIndexOf("/");
      return idx >= 0 ? s.slice(idx + 1) : s;
    }

    function getLiteVariantId(p) {
      var raw = p && (p.variant_id || p.variantId || p.first_variant_id || p.firstVariantId ||
        p.selected_or_first_available_variant_id || p.selectedOrFirstAvailableVariantId);

      if (typeof raw === "number") return String(raw);
      if (typeof raw === "string" && raw.replace(/^\s+|\s+$/g, "")) return raw.replace(/^\s+|\s+$/g, "");

      if (p && p.variants && p.variants.length) {
        var v0 = p.variants[0];
        var id = v0 && (v0.id || v0.variant_id || v0.variantId);
        if (typeof id === "number") return String(id);
        if (typeof id === "string" && id.replace(/^\s+|\s+$/g, "")) return id.replace(/^\s+|\s+$/g, "");
      }

      return "";
    }

    function setAttrAllProductLinks(tile, url) {
      if (!url) return;
      var as = tile.querySelectorAll('a[href*="/products/"]');
      for (var k = 0; k < as.length; k++) {
        as[k].setAttribute("href", url);
      }
    }

    function clearNode(node) {
      while (node && node.firstChild) node.removeChild(node.firstChild);
    }

    function egFindFirstTagValue(tags, match) {
      if (!tags || !tags.length || !match) return "";

      var starts = match.startsWith || match.starts_with || null;
      var contains = match.contains || match.includes || null;

      for (var i = 0; i < tags.length; i++) {
        var raw = String(tags[i] || "");
        if (!raw) continue;

        var k = raw.toLowerCase();

        var hit = false;

        if (starts && starts.length) {
          for (var s = 0; s < starts.length; s++) {
            var pref = String(starts[s] || "").toLowerCase();
            if (pref && k.indexOf(pref) === 0) { hit = true; break; }
          }
        }

        if (!hit && contains && contains.length) {
          for (var c = 0; c < contains.length; c++) {
            var sub = String(contains[c] || "").toLowerCase();
            if (sub && k.indexOf(sub) !== -1) { hit = true; break; }
          }
        }

        if (!hit) continue;

        // Value extraction (same logic you had)
        var v = raw;
        if (raw.indexOf("__") !== -1) v = raw.split("__").pop();
        else if (raw.indexOf("_") !== -1) v = raw.split("_").pop();

        v = String(v || "").replace(/^\s+|\s+$/g, "");
        return v;
      }

      return "";
    }

    function egFormatSpecValue(v, fmt) {
      v = String(v || "");
      if (!v) return "";

      if (fmt === "upper") return v.toUpperCase();
      if (fmt === "yesno") {
        var k = v.toLowerCase();
        if (k === "yes" || k === "true" || k === "1") return "Yes";
        if (k === "no" || k === "false" || k === "0") return "No";
        return v;
      }

      // default: title-ish
      return v.charAt(0).toUpperCase() + v.slice(1);
    }

    function egGetPillBgFromConfig(typeKey, pillKey, pillValue) {
      var cfg = window.EG_COLLECTION_CARD_PILL_COLORS;
      if (!cfg) return "";

      var t = String(typeKey || "").toLowerCase();
      var byType = cfg[t];
      if (!byType) return "";

      var k = String(pillKey || "").toLowerCase();
      var byKey = byType[k];
      if (!byKey) return "";

      var v = String(pillValue || "").toLowerCase().replace(/\s+/g, " ").trim();
      return byKey[v] || "";
    }

    function egExtractEtaFromTags(tags) {
      if (!tags || !tags.length) return "";
      for (var i = 0; i < tags.length; i++) {
        var t = String(tags[i] || "");
        if (t.indexOf("ETA__") !== -1) {
          // Liquid does: tag | split: 'ETA__' (you effectively want the suffix)
          var parts = t.split("ETA__");
          return String(parts[parts.length - 1] || "").trim();
        }
      }
      return "";
    }

    function egLiteIsAvailable(p) {
      // 1) Prefer endpoint booleans (most reliable)
      if (p && typeof p.variant_available === "boolean") return p.variant_available;
      if (p && typeof p.available === "boolean") return p.available;

      // 2) Fall back to shared helper if present
      var v;
      try { v = egGetLiteAvailable(p); } catch (e) {}

      if (v === true) return true;
      if (v === false) return false;

      if (typeof v === "number") return v > 0;

      if (typeof v === "string") {
        var s = v.replace(/^\s+|\s+$/g, "").toLowerCase();
        if (s === "true" || s === "1" || s === "yes") return true;
        if (s === "false" || s === "0" || s === "no") return false;
      }

      // 3) Unknown -> assume in stock (prevents mass-OOS styling)
      return true;
    }

    function setCardFromLite(tile, p, renderRank, collectionHandle) {
      var handle = egGetLiteHandle(p);
      var title = getLiteTitle(p);
      var url = getLiteUrl(p);

      setAttrAllProductLinks(tile, url);

      var img = getLiteImage(p);
      var priceTxt = getLitePriceText(p);
      var variantId = egGidToNumericId(getLiteVariantId(p));

      var inStock = egLiteIsAvailable(p);
      var isLegacy = !!(p && p.legacy_collection === true);

      tile.classList.toggle("product-item--sold-out", !inStock);
      tile.classList.toggle("sold-out", !inStock);
      tile.classList.toggle("is-sold-out", !inStock);

      tile.classList.toggle("eg-product--legacy", isLegacy);
      if (isLegacy) tile.setAttribute("data-eg-legacy", "1");
      else tile.removeAttribute("data-eg-legacy");

      (function () {
        var wrap = tile.querySelector(".product-item__image-wrapper");
        if (!wrap) return;

        var badge = wrap.querySelector(".eg-legacy-badge");

        if (isLegacy) {
          if (!badge) {
            badge = document.createElement("span");
            badge.className = "eg-legacy-badge";
            badge.textContent = "Not sold here";
            wrap.appendChild(badge);
          }
        } else if (badge && badge.parentNode) {
          badge.parentNode.removeChild(badge);
        }
      })();

      var fades = tile.querySelectorAll(".product-item__image-fade");
      for (var fi = 0; fi < fades.length; fi++) {
        var el = fades[fi];
        if (!el || !el.style) continue;

        // Legacy / compare-only items should not inherit sold-out dimming
        if (isLegacy) {
          el.style.opacity = "1";
          el.style.filter = "none";
          el.style.webkitFilter = "none";
        } else if (inStock) {
          el.style.opacity = "1";
          el.style.filter = "none";
          el.style.webkitFilter = "none";
        } else {
          el.style.opacity = "1";
          el.style.filter = "opacity(0.3)";
          el.style.webkitFilter = "opacity(0.3)";
        }
      }
      var addBtn = tile.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]');
      if (!addBtn) addBtn = tile.querySelector('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="button"]');
      var addFormEl = tile.querySelector('form[action*="/cart/add"]');

      // --- Match theme sold-out / preorder styling (from product-item liquid) ---
      (function () {
        var tags = (p && p.tags && p.tags.length) ? p.tags : [];
        var isPreorder = false;

        for (var i = 0; i < tags.length; i++) {
          var tt = String(tags[i] || "");
          if (!tt) continue;
          if (tt.toLowerCase() === "pre-order" || tt.toLowerCase() === "preorder") {
            isPreorder = true;
            break;
          }
        }

        // Card-level class (helps “greyed out” CSS if your theme uses it)
        if (!inStock && !isPreorder) {
          tile.classList.add("product-item--sold-out");
        } else {
          tile.classList.remove("product-item--sold-out");
        }

        // If template has no button (rare), don't try to restyle button text/classes.
        // Still allow the rest of the card to render.
        if (!addBtn) {
          return;
        }

        // Normalize classes: ensure we don't accumulate conflicting ones
        var cls = addBtn.className || "";

        // Pre-order wins (even if available is false, you want preorder UI)
        if (isPreorder) {
          addBtn.disabled = false;

          cls = cls.replace(/\bbutton--disabled\b/g, "button--primary");
          cls = cls.replace(/\bbutton--primary\b/g, "button--preorder");
          if (cls.indexOf("button--preorder") === -1) cls += " button--preorder";

          addBtn.className = cls;

          if (addBtn.tagName === "BUTTON") addBtn.textContent = "Pre-Order";
          else addBtn.value = "Pre-Order";
          return;
        }

        // Sold out
        if (!inStock) {
          addBtn.disabled = true;

          cls = cls.replace(/\bbutton--primary\b/g, "button--disabled");
          if (cls.indexOf("button--disabled") === -1) cls += " button--disabled";

          addBtn.className = cls;

          if (addBtn.tagName === "BUTTON") addBtn.textContent = "Sold out";
          else addBtn.value = "Sold out";
          return;
        }

        // In stock
        addBtn.disabled = false;

        cls = cls.replace(/\bbutton--disabled\b/g, "button--primary");
        if (cls.indexOf("button--primary") === -1) cls += " button--primary";

        addBtn.className = cls;

        if (addBtn.tagName === "BUTTON") addBtn.textContent = "Add to Bag";
        else addBtn.value = "Add to Bag";
      })();

      // ------------------------------
      // Rebuild product labels (from lite.labels)
      // Legacy / compare-only items should not inherit store-sale labels
      // ------------------------------
      (function () {

        // Remove any existing theme label list (safety)
        var old = tile.querySelector(".product-item__label-list");
        if (old && old.parentNode) old.parentNode.removeChild(old);

        // Legacy items should only show legacy-specific UI, not store trading labels
        if (isLegacy) return;
        if (!p || !p.labels) return;

        var L = p.labels;

        var isBfcm = !!L.is_bfcm;
        var isNew = !!L.is_new;
        var freeDelivery = !!L.free_delivery;
        var isOpenBox = !!L.is_open_box;
        var isPreorder = !!L.is_preorder;

        var html = "";

        // Match original Liquid priority
        if (isBfcm) {
          html += '<span class="product-label product-deal-label">BLACK FRIDAY</span>';
        } else {
          if (isNew) {
            html += '<span class="product-label product-new-label">New</span>';
          }
          if (isPreorder) {
            html += '<span class="product-label product-pre-order-label">Pre-Order</span>';
          }
          if (freeDelivery) {
            html += '<span class="product-label product-delivery-label">Free Delivery</span>';
          }
          if (isOpenBox) {
            html += '<span class="product-label product-deal-label">Open Box</span>';
          }
        }

        if (!html) return;

        var labelList = document.createElement("div");
        labelList.className = "product-item__label-list";
        labelList.innerHTML = html;

        // Insert before image wrapper (same as theme)
        var imgWrap = tile.querySelector("a.product-item__image-wrapper");
        if (imgWrap && imgWrap.parentNode) {
          imgWrap.parentNode.insertBefore(labelList, imgWrap);
        } else {
          tile.insertBefore(labelList, tile.firstChild);
        }

      })();

      egApplySortSpecPill(tile, p);
      egApplyPickerRecommendationBadge(tile, p, renderRank, collectionHandle);

      var aTitle = tile.querySelector("a.product-item__title");
      var aImg = tile.querySelector("a.product-item__image-wrapper");
      if (aTitle && url) aTitle.setAttribute("href", url);
      if (aImg && url) aImg.setAttribute("href", url);
      if (aTitle && title) aTitle.textContent = title;

      var imgEl = tile.querySelector("img.product-item__primary-image, img");
      if (imgEl && img) {
        // Hard-set the actual image URL
        imgEl.setAttribute("src", img);

        // Remove theme/lazysizes attributes that can leave images blank after DOM swaps
        imgEl.removeAttribute("srcset");
        imgEl.removeAttribute("sizes");
        imgEl.removeAttribute("data-src");
        imgEl.removeAttribute("data-srcset");
        imgEl.removeAttribute("data-sizes");
        imgEl.removeAttribute("data-widths");

        if (imgEl.classList) {
          // Kill any theme fade/lazy pipeline that may not re-run after skeleton swap
          imgEl.classList.remove("lazyload");
          imgEl.classList.remove("lazyloading");
          imgEl.classList.remove("lazyautosizes");
          imgEl.classList.remove("image--fade-in");
          imgEl.classList.add("lazyloaded");
        }

        // Force visible, but do NOT wipe sold-out image dimming
        imgEl.style.opacity = "1";
        imgEl.style.visibility = "visible";

        if (!(imgEl.classList && imgEl.classList.contains("product-item__image-fade") && !inStock)) {
          imgEl.style.filter = "none";
          imgEl.style.webkitFilter = "none";
        }

        // Load immediately (prevents intermittent blank images on initial paint)
        imgEl.setAttribute("loading", "eager");
        imgEl.setAttribute("decoding", "async");

        if (title) imgEl.setAttribute("alt", title);
      }

      (function () {
        // Prefer the same container the Liquid uses
        var priceListEl = tile.querySelector(".product-item__price-list");
        if (!priceListEl) {
          // fallback to old behavior if theme markup changes
          var priceEl = tile.querySelector(".price-list .price, .price");
          if (priceEl && priceTxt) priceEl.textContent = priceTxt;
          return;
        }

        function fmt(n, cur) {
          if (!isFinite(n)) return "";
          cur = String(cur || "").trim();
          if (!cur || cur === "GBP") return "£" + n.toFixed(2);
          return cur + " " + n.toFixed(2);
        }

        var cur = (p && p.currency) ? String(p.currency).trim() : "GBP";

        var min = (p && p.price_min != null) ? Number(p.price_min) : NaN;
        var max = (p && p.price_max != null) ? Number(p.price_max) : NaN;

        // compare_at_price comes from your lite payload (string/number). Treat 0/NaN as “no compare”.
        var cmp = (p && p.compare_at_price != null) ? Number(p.compare_at_price) : NaN;
        if (!isFinite(cmp) || cmp <= 0) cmp = NaN;

        // If min is missing, fall back to the existing “priceTxt”
        if (!isFinite(min)) {
          priceListEl.innerHTML = '<span class="price" data-money-convertible>' + String(priceTxt || "") + "</span>";
          return;
        }

        var varies = isFinite(max) && max > min;

        // On sale if compare-at exists and is greater than the effective current price (use min)
        var onSale = isFinite(cmp) && cmp > min;

        var html = "";

        if (onSale) {
          if (varies) {
            // Mimic Liquid “from … to …” roughly (no translation here)
            html += '<span class="price price--highlight">' + "From " + fmt(min, cur) + " - " + fmt(max, cur) + "</span>";
          } else {
            html += '<span class="price price--highlight" data-money-convertible>' + fmt(min, cur) + "</span>";
          }

          html += '<span class="price price--compare" data-money-convertible>' + fmt(cmp, cur) + "</span>";

          // % OFF label (same idea as Liquid percentage mode)
          // Legacy / compare-only items should not show store sale messaging
          if (!isLegacy) {
            var pct = Math.round(((cmp - min) * 100) / cmp);
            if (isFinite(pct) && pct > 0) {
              html += '<span class="sale__label-list"><span class="product-label--on-sale">' + pct + "% OFF</span></span>";
            }
          }
        } else {
          if (varies) {
            html += '<span class="price">' + "From " + fmt(min, cur) + " - " + fmt(max, cur) + "</span>";
          } else {
            html += '<span class="price" data-money-convertible>' + fmt(min, cur) + "</span>";
          }
        }

        priceListEl.innerHTML = html;
      })();

      var variantInput = tile.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;

      // --- Card pills (overlay badges from config) ---
      (function () {
        var tags = (p && p.tags && p.tags.length) ? p.tags : [];
        if (!tags.length) return;

        var cfg0 = window.EG_COLLECTION_CARD_SPECS;
        if (!cfg0) return;

        var typeKey0 = String(p.type || "").toLowerCase();
        var rule0 = (cfg0.types && cfg0.types[typeKey0]) ? cfg0.types[typeKey0] : null;

        var pills0 = (rule0 && Array.isArray(rule0.pills)) ? rule0.pills : ((cfg0.default && Array.isArray(cfg0.default.pills)) ? cfg0.default.pills : []);
        if (!pills0 || !pills0.length) return;

        // Host = image wrapper (so it sits "on top of the card")
        var imgWrap0 = tile.querySelector(".product-item__image-wrapper") || tile;

        // Remove only previous spec pills, not picker recommendation pills
        var old = tile.querySelector(".eg-card-pills--specs");
        if (old && old.parentNode) old.parentNode.removeChild(old);

        var wrap = document.createElement("div");
        wrap.className = "eg-card-pills eg-card-pills--specs";

        for (var i = 0; i < pills0.length; i++) {
          var def = pills0[i];
          if (!def || !def.tags || !def.tags.length) continue;

          var val = egFindFirstTagValue(tags, { startsWith: def.tags });
          val = egFormatSpecValue(val, def.format || "");
          var pillValue = val;
          if (!val) continue;

          var pill = document.createElement("span");
          pill.className = "eg-card-pill";
          pill.textContent = val;

          // APPLY CONFIGURED COLOUR (EXACT PLACEMENT)
          var pillKey = def.key || def.label || def.tags[0].replace(/__$/, "");
          var bg = egGetPillBgFromConfig(typeKey0, pillKey, pillValue);
          if (bg) {
            pill.style.backgroundColor = bg;
            pill.style.borderColor = bg;
            pill.style.color = "#fff";
          }

          wrap.appendChild(pill);
        }

        if (!wrap.childNodes || !wrap.childNodes.length) return;

        imgWrap0.appendChild(wrap);
      })();

      // --- Rebuild card-content-2 from config + lite tags (per product) ---
      (function () {
        var tags = (p && p.tags && p.tags.length) ? p.tags : [];
        if (!tags.length) return;

        var cfg0 = window.EG_COLLECTION_CARD_SPECS;
        if (!cfg0) return;

        var typeKey0 = String(p.type || "").toLowerCase();
        var rule0 = (cfg0.types && cfg0.types[typeKey0]) ? cfg0.types[typeKey0] : null;
        var rows0 = (rule0 && rule0.rows && rule0.rows.length) ? rule0.rows : ((cfg0.default && cfg0.default.rows) ? cfg0.default.rows : []);

        if (!rows0 || !rows0.length) return;

        // Ensure block exists
        var specBlock = tile.querySelector(".card-content-2");
        if (!specBlock) {
          specBlock = document.createElement("div");
          specBlock.className = "card-content-2";
          var imgWrap = tile.querySelector(".product-item__image-wrapper") || tile;
          imgWrap.appendChild(specBlock);
        }

        var html = '<table><tbody>';

        for (var r = 0; r < rows0.length; r++) {
          var row = rows0[r];
          if (!row) continue;

          var label = String(row.label || "");
          var val = egFindFirstTagValue(tags, { startsWith: row.tags || [] });
          val = egFormatSpecValue(val, row.format || "");

          if (!label || !val) continue;

          html += "<tr><td>" + label + "</td><td><span>" + val + "</span></td></tr>";
        }

        html += "</tbody></table>";
        specBlock.innerHTML = html;
      })();

      egApplySortSpecPill(tile, p);

    // --- Inventory (match product-item Liquid behaviour as closely as possible) ---
    (function () {
      var infoInner =
        tile.querySelector(".product-item__info-inner") ||
        tile.querySelector(".product-item__info") ||
        null;
      if (!infoInner) return;

      // Remove any previous inventory span we injected
      var old = infoInner.querySelector(".product-item__inventory");
      if (old) old.parentNode.removeChild(old);

      var tags = (p && p.tags && p.tags.length) ? p.tags : [];
      var eta = egExtractEtaFromTags(tags);

      // If ETA tag exists, show ETA line (Liquid shows this in several branches). :contentReference[oaicite:1]{index=1}
      if (eta) {
        var s1 = document.createElement("span");
        s1.className = "product-item__inventory inventory inventory--pre-order";
        s1.innerHTML =
          '<img class="lazyload image--fade-in" src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/clock.png?v=1658932284" height="24px" width="18px" />' +
          " ETA: " + eta;
        infoInner.appendChild(s1);
        return;
      }

      var isAvailable = egLiteIsAvailable(p);

      if (!isAvailable) {
        var s2 = document.createElement("span");
        s2.className = "product-item__inventory inventory";
        s2.style.display = "none"; // matches your Liquid spans
        s2.innerHTML =
          '<img class="lazyload image--fade-in" src="https://cdn.shopify.com/s/files/1/0102/8426/9615/files/arrow-down-circle_24x24_1x_1.svg?v=1602338276"/>' +
          " Sold out";
        infoInner.appendChild(s2);
      }
    })();

      var pid = p && (p.id || p.product_id || p.productId);
      var pidInput = tile.querySelector('form[action*="/cart/add"] input[name="product-id"]');
      if (pidInput && pid != null) pidInput.value = String(pid);
    
    // =========================================================
    // Compare button
    // =========================================================

    if (typeof egCompareGetCollectionHandle === "function") {
      var productHandle = String(p && p.handle || "").trim();
      if (productHandle) {

        var existingBtn = tile.querySelector("[data-eg-compare-toggle]");
        if (existingBtn && existingBtn.parentNode) {
          existingBtn.parentNode.removeChild(existingBtn);
        }

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "eg-compare-toggle";
        btn.setAttribute("data-eg-compare-toggle", "");
        btn.setAttribute("data-eg-compare-handle", productHandle);
        btn.setAttribute("aria-pressed", "false");

        btn.innerHTML =
          '<span data-eg-compare-toggle-text>Compare</span>';

        // Insert into card content area (safe fallback approach)
        var content =
          tile.querySelector(".card-content") ||
          tile.querySelector(".product-item__info") ||
          tile;

        content.appendChild(btn);
      }
    }
    
    }

    function buildStockFirstOrder(arr) {
      var inS = [];
      var outS = [];

      for (var j = 0; j < arr.length; j++) {
        var p = arr[j];
        var ok = egLiteIsAvailable(p);

        if (ok) inS.push(p);
        else outS.push(p);
      }

      return inS.concat(outS);
    }

    function getUrlCacheKey() {
      // Page should not affect the filtered set
      var u = new URL(window.location.href);
      u.searchParams.delete("page");

      // Include pathname so tag-path filters don't collapse to "__base__"
      var qs = u.searchParams.toString();
      return (u.pathname || "") + "?" + (qs || "");
    }

    function egApplyAvailabilityFacetFromUrl(arr) {
      var sp = new URLSearchParams(window.location.search || "");
      var vals = sp.getAll("filter.v.availability");
      if (!vals || !vals.length) return arr;

      var wantIn = false;
      var wantOut = false;

      for (var i = 0; i < vals.length; i++) {
        var v = String(vals[i] || "").replace(/^\s+|\s+$/g, "");
        if (v === "1" || v === "true") wantIn = true;
        if (v === "0" || v === "false") wantOut = true;
      }

      // both selected => no-op
      if (wantIn && wantOut) return arr;

      var out = [];
      for (var j = 0; j < (arr || []).length; j++) {
        var p = arr[j];
        var ok = true;
        try { ok = egLiteIsAvailable(p); } catch (e) {}

        if (wantIn) { if (ok) out.push(p); }
        else if (wantOut) { if (!ok) out.push(p); }
        else out.push(p);
      }

      return out;
    }

    function egShowLegacyFromUrl() {
      var sp = new URLSearchParams(window.location.search || "");
      return sp.get("eg_show_legacy") === "1";
    }

function egLegacyAllowed() {
  // Legacy products should NEVER show unless explicitly enabled
  return egShowLegacyFromUrl() === true;
}

// Default state: show only NON-legacy products.
// When legacy is enabled, show everything.
function egApplyLegacyToggleFromUrl(arr) {
  if (egLegacyAllowed()) return arr;

  var out = [];
  for (var i = 0; i < (arr || []).length; i++) {
    var p = arr[i];
    var v = (p && (p.legacy_collection !== undefined)) ? p.legacy_collection : null;

    var isFalse = (v === false || v === 0 || v === "0" || v === "false");
    if (isFalse) out.push(p);
  }
  return out;
}

function egLegacyIsOn() {
  return egShowLegacyFromUrl() === true;
}

function egLegacyBasePool(allLite) {
  if (egLegacyIsOn()) return allLite || [];
  return egApplyLegacyToggleFromUrl(allLite || []);
}

function egSetLegacyOnlyOptionState(label, input, existsInNonLegacyPool) {
  if (!label) return;

  var hide = (!egLegacyIsOn() && !existsInNonLegacyPool && !(input && input.checked));

  if (label.classList) label.classList.toggle("eg-legacy-only-option", hide);
}

function egRefreshLegacyOnlyGroupVisibility(root) {
  if (!root) return;

  var groups = root.querySelectorAll(".eg-filter-group[data-eg-filter-key], .eg-filter-group[data-eg-kind='tag-group'], .eg-filter-group[data-eg-kind='tag-set']");
  for (var i = 0; i < groups.length; i++) {
    var group = groups[i];
    var scope = group.__egPanel || group;

    var options = scope.querySelectorAll("label.eg-filter-option");
    if (!options.length) {
      group.classList.remove("eg-legacy-only-group");
      continue;
    }

    var anyVisible = false;
    for (var j = 0; j < options.length; j++) {
      if (!options[j].classList.contains("eg-legacy-only-option")) {
        anyVisible = true;
        break;
      }
    }

    group.classList.toggle("eg-legacy-only-group", !egLegacyIsOn() && !anyVisible);
  }
}

window.egRefreshLegacyOnlyGroupVisibility = egRefreshLegacyOnlyGroupVisibility;

    function egUpdateAvailabilityFacetCounts(root, allLite) {
      if (!root || !allLite || !allLite.length) return;

      // Build current selections, but IGNORE availability (so we can facet it properly)
      var shopifySel = egGetActiveShopifyFacetSelectionsFromUrl();
      var egSel = egBuildEgTagSelectionsFromUrlAsFullTags();

      // Clone shopifySel without availability
      var shopifyNoAvail = new Map();
      shopifySel.forEach(function (set, key) {
        if (key === "filter.v.availability") return;
        shopifyNoAvail.set(key, set);
      });

      // Base pool = matches everything except availability, and respect legacy toggle
      var base0 = [];
      for (var i = 0; i < allLite.length; i++) {
        var p = allLite[i];
        if (egProductMatchesSelections(p, shopifyNoAvail, egSel)) base0.push(p);
      }

      var base = egApplyLegacyToggleFromUrl(base0);

      // Count in/out within that base pool
      var inCount = 0;
      var outCount = 0;
      for (var j = 0; j < base.length; j++) {
        if (egLiteIsAvailable(base[j])) inCount++;
        else outCount++;
      }

      // Permanent non-legacy existence for availability values
      var legacyBaseAll = egLegacyBasePool(allLite);
      var existsInNonLegacyIn = 0;
      var existsInNonLegacyOut = 0;
      for (var j2 = 0; j2 < legacyBaseAll.length; j2++) {
        if (egLiteIsAvailable(legacyBaseAll[j2])) existsInNonLegacyIn++;
        else existsInNonLegacyOut++;
      }

      // Update the UI for the availability checkboxes
      var inputs = root.querySelectorAll('input[type="checkbox"][data-filter-key][name="filter.v.availability"]');
      for (var k = 0; k < inputs.length; k++) {
        var cb = inputs[k];
        var v = String(cb.value || "").replace(/^\s+|\s+$/g, "");
        var count = 0;

        var existsInNonLegacyPool = true;

        // Shopify typically uses "1" for in stock, "0" for out of stock
        if (v === "1" || v === "true") {
          count = inCount;
          existsInNonLegacyPool = existsInNonLegacyIn > 0;
        } else if (v === "0" || v === "false") {
          count = outCount;
          existsInNonLegacyPool = existsInNonLegacyOut > 0;
        }

        var label = cb.closest ? cb.closest("label") : null;
        if (!label) continue;

        var countEl = label.querySelector(".eg-filter-option-count");
        if (!countEl) {
          countEl = document.createElement("span");
          countEl.className = "eg-filter-option-count";
          label.appendChild(countEl);
        }
        countEl.textContent = "(" + count + ")";

        // Disable if nothing available for that option (unless already checked)
        var shouldDisable = (count === 0 && !cb.checked);
        cb.disabled = shouldDisable;
        if (label.classList) label.classList.toggle("is-disabled", shouldDisable);

        egSetLegacyOnlyOptionState(label, cb, existsInNonLegacyPool);
      }
        egRefreshLegacyOnlyGroupVisibility(root);
    }

      function egUpdateSimpleFacetCounts(root, allLite, facetKey, getValueFn) {
        if (!root || !allLite || !allLite.length || !facetKey || typeof getValueFn !== "function") return;

        // Current selections
        var shopifySel = egGetActiveShopifyFacetSelectionsFromUrl();
        var egSel = egBuildEgTagSelectionsFromUrlAsFullTags();

        // Clone shopifySel but remove THIS facet (so we can facet it properly)
        var shopifyMinus = new Map();
        shopifySel.forEach(function (set, key) {
          if (key === facetKey) return;
          shopifyMinus.set(key, set);
        });

        // Base pool = matches everything except this facet
        var base0 = [];
        for (var i = 0; i < allLite.length; i++) {
          var p = allLite[i];
          if (egProductMatchesSelections(p, shopifyMinus, egSel)) base0.push(p);
        }

        // Respect legacy toggle first, then availability
        var base1 = egApplyLegacyToggleFromUrl(base0);
        var base = egApplyAvailabilityFacetFromUrl(base1);

        // Count values for this facet
        var counts = new Map(); // value -> count
        for (var j = 0; j < base.length; j++) {
          var val = "";
          try { val = getValueFn(base[j]); } catch (e) { val = ""; }
          val = String(val || "").replace(/^\s+|\s+$/g, "");
          if (!val) continue;
          counts.set(val, (counts.get(val) || 0) + 1);
        }

        // Permanent non-legacy existence map for this facet
        var legacyBase = egLegacyBasePool(allLite);
        var existsInNonLegacy = new Map();
        for (var j2 = 0; j2 < legacyBase.length; j2++) {
          var val2 = "";
          try { val2 = getValueFn(legacyBase[j2]); } catch (e2) { val2 = ""; }
          val2 = String(val2 || "").replace(/^\s+|\s+$/g, "");
          if (!val2) continue;
          existsInNonLegacy.set(val2, true);
        }

        // Update UI checkboxes for this facet.
        // Panels may be teleported into the overlay (group.__egPanel), so scope queries accordingly.
        var groups = root.querySelectorAll('.eg-filter-group[data-eg-filter-key="' + facetKey + '"]');
        for (var g = 0; g < groups.length; g++) {
          var group = groups[g];
          var scope = group.__egPanel || group;

          var inputs = scope.querySelectorAll('input[type="checkbox"][data-filter-key][name="' + facetKey + '"]');
          for (var k = 0; k < inputs.length; k++) {
            var cb = inputs[k];
            var v = String(cb.value || "").replace(/^\s+|\s+$/g, "");
            var c = counts.get(v) || 0;

            var label = cb.closest ? cb.closest("label") : null;
            if (!label) continue;

            var countEl = label.querySelector(".eg-filter-option-count");
            if (!countEl) {
              countEl = document.createElement("span");
              countEl.className = "eg-filter-option-count";
              label.appendChild(countEl);
            }
            countEl.textContent = "(" + c + ")";

            var shouldDisable = (c === 0 && !cb.checked);
            cb.disabled = shouldDisable;
            if (label.classList) label.classList.toggle("is-disabled", shouldDisable);

            egSetLegacyOnlyOptionState(label, cb, !!existsInNonLegacy.get(v));
          }
        }
        egRefreshLegacyOnlyGroupVisibility(root);
      }

  function computeFilteredLite(allLite) {
    var key = getUrlCacheKey();

    if (__egFilterCache[key] && __egFilterCache[key].arr) {
        return { arr: __egFilterCache[key].arr };
    }

    var shopifySel = egGetActiveShopifyFacetSelectionsFromUrl();
    var egSel = egBuildEgTagSelectionsFromUrlAsFullTags();

    var anyShopify = false;
    shopifySel.forEach(function (set) { if (set && set.size) anyShopify = true; });

    var anyEg = false;
    egSel.forEach(function (set2) { if (set2 && set2.size) anyEg = true; });

    var hasRanges = false;
    try {
      if (typeof egReadNumericRangesFromUrl === "function") {
        var rr = egReadNumericRangesFromUrl();
        hasRanges = !!(rr && rr.length);
      }
    } catch (e) {}

    var hasPrice = false;
    try {
      if (typeof egReadPriceRangeFromUrl === "function") {
        hasPrice = !!egReadPriceRangeFromUrl();
      }
    } catch (e2) {}

    var arr = allLite;
    if (anyShopify || anyEg || hasRanges || hasPrice) {
      var out = [];
      for (var k = 0; k < allLite.length; k++) {
        if (egProductMatchesSelections(allLite[k], shopifySel, egSel)) out.push(allLite[k]);
      }
      arr = out;
    }

    arr = egApplyLegacyToggleFromUrl(arr);
    arr = egApplyAvailabilityFacetFromUrl(arr);
    arr = buildStockFirstOrder(arr);

    // Save to cache + simple eviction
    __egFilterCache[key] = { arr: arr };
    __egFilterCacheKeys.push(key);

    if (__egFilterCacheKeys.length > __egFilterCacheMax) {
        var drop = __egFilterCacheKeys.shift();
        if (drop && __egFilterCache[drop]) delete __egFilterCache[drop];
    }

    return { arr: arr };
    }

    function renderPager(pagerHost, pageNum, totalFiltered) {
      var totalPages = pageSize > 0 ? Math.ceil(totalFiltered / pageSize) : 0;

      var sig = pageNum + "|" + totalPages;
      if (pagerHost.__egPagerSig === sig) return;
      pagerHost.__egPagerSig = sig;

      if (totalPages <= 1) {
        clearNode(pagerHost);
        return;
      }

      function addBtn(parent, label, cls, disabled, onClick) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = cls;
        b.disabled = !!disabled;
        b.innerHTML = label;
        b.addEventListener("click", function () {
          if (b.disabled) return;
          onClick();
        });
        parent.appendChild(b);
        return b;
      }

      function addPage(parent, n, isActive) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "eg-client-pager-page" + (isActive ? " is-active" : "");
        b.disabled = !!isActive;
        b.textContent = String(n);
        b.addEventListener("click", function () {
          if (isActive) return;
          goToPage(n);
        });
        parent.appendChild(b);
      }

      function addEllipsis(parent) {
        var s = document.createElement("span");
        s.className = "eg-client-pager-ellipsis";
        s.textContent = "…";
        parent.appendChild(s);
      }

      // Build list of page numbers to show
      var pages = [];
      var i;

      if (totalPages <= 7) {
        for (i = 1; i <= totalPages; i++) pages.push(i);
      } else {
        // Always show: 1, (window), last
        pages.push(1);

        var start = pageNum - 1;
        var end = pageNum + 1;

        if (start < 2) { start = 2; end = 4; }
        if (end > totalPages - 1) { end = totalPages - 1; start = totalPages - 3; }
        if (start < 2) start = 2;

        // gap after 1
        if (start > 2) pages.push("…");

        for (i = start; i <= end; i++) pages.push(i);

        // gap before last
        if (end < totalPages - 1) pages.push("…");

        pages.push(totalPages);
      }

      var wrap = document.createElement("div");
      wrap.className = "eg-client-pager";

      // Previous
      addBtn(
        wrap,
        '&#x2039; <span>Prev</span>',
        "eg-client-pager-btn eg-client-pager-prev",
        pageNum <= 1,
        function () { goToPage(pageNum - 1); }
      );

      // Pages
      var pagesWrap = document.createElement("div");
      pagesWrap.className = "eg-client-pager-pages";

      for (i = 0; i < pages.length; i++) {
        var p = pages[i];
        if (p === "…") addEllipsis(pagesWrap);
        else addPage(pagesWrap, p, p === pageNum);
      }

      wrap.appendChild(pagesWrap);

      // Next
      addBtn(
        wrap,
        '<span>Next</span> &#x203A;',
        "eg-client-pager-btn eg-client-pager-next",
        pageNum >= totalPages,
        function () { goToPage(pageNum + 1); }
      );

      clearNode(pagerHost);
      pagerHost.appendChild(wrap);
    }

    function updateCounters(pageNum, totalFiltered) {
      var start = (pageNum - 1) * pageSize;
      var end = start + pageSize;

      var from = totalFiltered === 0 ? 0 : (start + 1);
      var to = totalFiltered === 0 ? 0 : Math.min(end, totalFiltered);

      if (typeof egUpdateClientSideResultCounters === "function") {
        egUpdateClientSideResultCounters(from, to, totalFiltered);
      }
    }

    function egScrollToTopAfterPaging() {
      // Scroll to the top of the results list (NOT the sticky bar)
      var target = listEl;
      if (!target || !target.getBoundingClientRect) return;

      var y = target.getBoundingClientRect().top + window.pageYOffset;

      // Subtract sticky filterbar occupied space (top offset + height)
      var fb = document.getElementById("eg-collection-filters");
      if (fb && window.getComputedStyle && fb.getBoundingClientRect) {
        try {
          var cs = getComputedStyle(fb);
          var topPx = parseFloat(cs.top || "0") || 0;
          var h = fb.getBoundingClientRect().height || 0;
          y = y - topPx - h - 8;
        } catch (e) {
          y = y - 8;
        }
      } else {
        y = y - 8;
      }

      if (y < 0) y = 0;

      try {
        window.scrollTo({ top: y, left: 0, behavior: "smooth" });
      } catch (e) {
        window.scrollTo(0, y);
      }
    }

    function goToPage(n) {
      var u3 = new URL(window.location.href);
      var sp = u3.searchParams;

      if (n <= 1) sp.delete("page");
      else sp.set("page", String(n));

      u3.search = sp.toString();
      writeUrlNoReload(u3.toString());

      renderNow().then(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            egScrollToTopAfterPaging();
          });
        });
      }, function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            egScrollToTopAfterPaging();
          });
        });
      });
    }

    function applyUrlFromShopifyFacetCheckbox(cb) {
      var name = cb.getAttribute("name") || "";
      var value = cb.value || "";
      if (name.indexOf("filter.") !== 0) return;

      var url = new URL(window.location.href);
      var sp = url.searchParams;

      // Support "pretty" alias params too (e.g. vendor=Artisan)
      var cfg = window.EG_URL_PRETTY || {};
      var facetAliases = cfg.facetParamAliases || {};
      var aliasKey = facetAliases[name] ? String(facetAliases[name]) : "";

      // Read existing values from BOTH long key and alias key
      var existing = sp.getAll(name);
      if (aliasKey) {
        var a2 = sp.getAll(aliasKey);
        for (var i0 = 0; i0 < a2.length; i0++) existing.push(a2[i0]);
      }

      var next = [];
      var x;

      if (cb.checked) {
        var has = false;
        for (x = 0; x < existing.length; x++) if (String(existing[x]) === String(value)) has = true;
        next = existing.slice();
        if (!has) next.push(value);
      } else {
        for (x = 0; x < existing.length; x++) if (String(existing[x]) !== String(value)) next.push(existing[x]);
      }

      // Delete BOTH keys, then re-append under the long key (pretty writer will convert)
      sp.delete(name);
      if (aliasKey) sp.delete(aliasKey);

      for (x = 0; x < next.length; x++) sp.append(name, next[x]);

      sp.delete("page"); // reset paging on filter change

      url.search = sp.toString();
      writeUrlNoReload(url.toString());
    }

function applyUrlFromEgTagCheckbox(cb) {
  var groupKey = String(cb.getAttribute("data-eg-tag-group") || cb.dataset.egTagGroup || "");
  var mode = String(cb.getAttribute("data-eg-mode") || cb.dataset.egMode || "single");
  if (!groupKey) return;

  // Canonical handle for this checkbox (fullTag -> handle)
  var handle = "";
  try {
    var fullTag = String(cb.value || "").replace(/^\s+|\s+$/g, "");
    if (fullTag && typeof egBuildTagHandleLookup === "function") {
      var byTag = egBuildTagHandleLookup();
      if (byTag && byTag.get) {
        var mapped = byTag.get(fullTag);
        if (mapped) handle = String(mapped).replace(/^\s+|\s+$/g, "");
      }
    }
  } catch (eMap) {}
  if (!handle) {
    handle = String(cb.getAttribute("data-eg-tag-handle") || cb.dataset.egTagHandle || "").replace(/^\s+|\s+$/g, "");
  }
  if (!handle) return;

  var url = new URL(window.location.href);
  var sp = url.searchParams;

  var paramLong = "eg_tag_" + groupKey;

  // If this group has a pretty alias (e.g. glide), we must delete it before rewriting
  var cfg = window.EG_URL_PRETTY || {};
  var tagAliases = cfg.tagParamAliases || {};
  var paramAlias = tagAliases[groupKey] ? String(tagAliases[groupKey]) : "";

  // Read current selection set via the canonical reader (handles pretty keys too)
  var current = {};
  try {
    if (typeof egReadActiveEgTagParams === "function") {
      var active = egReadActiveEgTagParams(); // Map(groupKey -> Set(handles))
      var set = active && active.get ? active.get(groupKey) : null;
      if (set && set.forEach) {
        set.forEach(function (h) {
          h = String(h || "").replace(/^\s+|\s+$/g, "");
          if (h) current[h] = true;
        });
      }
    }
  } catch (eRead) {}

  // SINGLE mode: force-uncheck all other checkboxes for this groupKey (document-wide, works with teleported panels)
  if (mode === "single") {
    current = {};
    try {
      var all = document.querySelectorAll('input[type="checkbox"][data-eg-kind="tag"]');
      for (var i = 0; i < all.length; i++) {
        var inp = all[i];
        if (!inp || inp === cb) continue;
        if (String(inp.dataset.egTagGroup || "") !== groupKey) continue;
        inp.checked = false;
      }
    } catch (eUi) {}
  }

  // Toggle
  if (cb.checked) current[handle] = true;
  else delete current[handle];

  // Clean both forms then write only eg_tag_* (prettifier can render a pretty view)
  sp.delete(paramLong);

  // delete alias key too, otherwise it accumulates like glide=a&glide=a&...
  if (paramAlias) sp.delete(paramAlias);

  sp.delete(groupKey); // remove any direct pretty param that might exist

  for (var k in current) if (current.hasOwnProperty(k)) sp.append(paramLong, k);

  sp.delete("filter.p.tag");
  sp.delete("page");

  url.search = sp.toString();
  writeUrlNoReload(url.toString());
}

    var liteAll = null;
    var __egFilterCache = {};       // key -> { arr, total }
    var __egFilterCacheKeys = [];   // FIFO keys for eviction
    var __egFilterCacheMax = 30;    // keep last 30 states
    var renderQueued = false;

    function ensureLite() {
      if (liteAll && liteAll.length) return Promise.resolve(liteAll);

      var handle = String(root.dataset.egCollection || "");
      if (!handle) return Promise.resolve(null);

      return egGetFullCollectionProducts(handle).then(function (arr) {
        if (!arr || !arr.length) return null;
        liteAll = arr;
        __egFilterCache = {};
        __egFilterCacheKeys = [];
        return liteAll;
      });
    }

    function queueRender() {
      if (renderQueued) return;
      renderQueued = true;
      requestAnimationFrame(function () {
        renderQueued = false;
        renderNow();
      });
    }

    // Expose refresh hook for other modules (pills / clear button)
    root.__egClientRenderRefresh = queueRender;

    function renderNow() {
      setLoading(true);
      return ensureLite().then(function (all) {
        if (!all) { setLoading(false); return; }

        // =========================================================
        // Compare — expose lite map (handle -> product)
        // =========================================================
        window.__EG_COMPARE_LITE_MAP = window.__EG_COMPARE_LITE_MAP || {};
        for (var i = 0; i < all.length; i++) {
          var p0 = all[i];
          if (!p0 || !p0.handle) continue;
          window.__EG_COMPARE_LITE_MAP[p0.handle] = p0;
        }

        var pageNum = readPageNumFromUrl();
        var out = computeFilteredLite(all);
        var arr = out.arr || [];
        var totalFiltered = arr.length;

        var emptyEl = document.getElementById("eg-collection-empty-state");

        // Smart header (default + filtered)
        // Allow freezing via config flag
        if (window.EG_SMART_HEADER_ENABLED !== false && typeof egUpdateSmartCollectionHeader === "function") {
          try { egUpdateSmartCollectionHeader(root, totalFiltered, (all && all.length) ? all.length : 0); } catch (e) {}
        }

        // Apply EG sort (keeps stock-first: sorts only within in-stock bucket, then within OOS bucket)
        if (typeof egReadSortKeyFromUrl === "function" && typeof egSortLiteWithinStockBuckets === "function") {
          arr = egSortLiteWithinStockBuckets(arr, egReadSortKeyFromUrl());
          totalFiltered = arr.length;
        }

        pageSize = initialPageSize;

        var start = (pageNum - 1) * pageSize;
        var end = start + pageSize;
        var pageItems = arr.slice(start, end);

        // One-pass DOM update
        var frag = document.createDocumentFragment();
        var pickerCollectionHandle = egGetCollectionHandleFromDom();

        for (var r = 0; r < pageItems.length; r++) {
          var tile = templateTile.cloneNode(true);
          setCardFromLite(tile, pageItems[r], r, pickerCollectionHandle);
          frag.appendChild(tile);
        }

        clearNode(listEl);

        if (!totalFiltered) {
          if (emptyEl) emptyEl.style.display = "";
          listEl.style.display = "none";
        } else {
          if (emptyEl) emptyEl.style.display = "none";
          listEl.style.display = "";
          listEl.appendChild(frag);
        }

        // Adverts: always inject (unfiltered + filtered + paging)
        if (window.EG_CLIENT_RENDER_ADVERTS === true && typeof egInjectAdvertsIntoList === "function") {
          try { egInjectAdvertsIntoList(listEl); } catch (e) {}
        }

        updateCounters(pageNum, totalFiltered);

        var pagerHost = getOrCreatePager();
        renderPager(pagerHost, pageNum, totalFiltered);

        var tagUiPromise = null;

        if (typeof egUpdateEgTagGroupCountsAndDisabledFromLite === "function") {
          try {
            tagUiPromise = egUpdateEgTagGroupCountsAndDisabledFromLite(root);
          } catch (e) {
            tagUiPromise = null;
          }
        }

        // Always run facet count refresh + UI refresh, even if tag UI errors
        return Promise.resolve(tagUiPromise).catch(function () {}).then(function () {
          if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
          if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();

          // Availability + vendor + product type option counts should respond to EG tag filters too
          if (typeof egUpdateAvailabilityFacetCounts === "function") {
            egUpdateAvailabilityFacetCounts(root, all);
          }

          egUpdateSimpleFacetCounts(root, all, "filter.p.vendor", function (p) { return p && p.vendor ? p.vendor : ""; });
          egUpdateSimpleFacetCounts(root, all, "filter.p.product_type", function (p) { return p && p.type ? p.type : ""; });
          if (typeof egApplyShopifyFacetValueRenames === "function") {
            egApplyShopifyFacetValueRenames(root);
          }
          if (typeof egApplyAppliedPillValueRenames === "function") {
            egApplyAppliedPillValueRenames(root);
          }
          if (typeof egApplyFilterOptionOrdering === "function") {
            egApplyFilterOptionOrdering(root);
          }
          if (typeof egCompareRenderTray === "function") {
            egCompareRenderTray(root);
          }
        });
      }).finally(function () {
        setLoading(false);
      });
    }

    function bindClientNav() {
      if (root.__egClientNavBound) return;
      root.__egClientNavBound = true;

      // Use DOCUMENT capture so we catch checkbox changes even if panels are teleported
      if (!window.__egClientNavDocBound) {
        window.__egClientNavDocBound = true;

        document.addEventListener("change", function (e) {
          var t = e && e.target;
          if (!t || t.tagName !== "INPUT" || t.type !== "checkbox") return;

          // Only respond to inputs that are part of our EG filter UI
          // (either inside #eg-collection-filters OR inside a teleported .eg-filter-options panel)
          var inEg =
            (t.closest && t.closest("#eg-collection-filters")) ||
            (t.closest && t.closest(".eg-filter-options[data-eg-managed='1']"));

          if (!inEg) return;

          // Prevent theme facet scripts from handling our custom filter UI (they can error on missing DOM)
          if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
          else if (typeof e.stopPropagation === "function") e.stopPropagation();

          if (t.matches && t.matches('input[type="checkbox"][data-filter-key]')) {
            applyUrlFromShopifyFacetCheckbox(t);
            queueRender();
            return;
          }

          if (t.matches && t.matches('input[type="checkbox"][data-eg-kind="tag"]')) {
            applyUrlFromEgTagCheckbox(t);
            queueRender();
            return;
          }
        }, true);
      }

      window.addEventListener("popstate", function () {
        queueRender();
      });
    }

    bindClientNav();
    getOrCreatePager();
    hideThemePagination();
    queueRender();

    return true;
  }

  // Export global (Shopify CDN-safe)
  window.egClientRenderInit = egClientRenderInit;
})();
